import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { LOCATION_TYPES } from "constants/lessonRequest";

export default function Step3Details({
    requestType,
    participantCount,
    setParticipantCount,
    message,
    setMessage,
    locationType,
    setLocationType,
    locationQuery,
    locationItems,
    locationId,
    setLocationId,
}) {
    return (
        <div className="step-view">
            <section className="section-group">
                <div className="section-group__header">
                    <h3>어디서 수업할까요?</h3>
                </div>
                <div className="lr-tabs">
                    {LOCATION_TYPES.map((label) => (
                        <button
                            type="button"
                            key={label}
                            className={`btn ${locationType === label ? "btn-purple500" : "btn-outline-gray200"}`}
                            onClick={() => setLocationType(label)}
                        >
                            {label}
                        </button>
                    ))}
                </div>
                <div className="lr-location-meta">
                    <span>{locationQuery ? "검색 결과" : `${locationType} ${locationItems.length}개`}</span>
                </div>
                <div className="location-cards-scroll">
                    {locationItems.map((loc) => (
                        <div
                            key={loc.id}
                            className={`location-item-card ${String(locationId) === String(loc.id) ? "is-active" : ""}`}
                            onClick={() => setLocationId(String(loc.id))}
                        >
                            <div className="location-item-card__thumb">
                                {loc.image ? (
                                    <img src={loc.image} alt="" />
                                ) : (
                                    <div className="location-item-card__thumb--empty">⌖</div>
                                )}
                            </div>
                            <strong>{loc.label}</strong>
                            <small>{loc.sub}</small>
                        </div>
                    ))}
                </div>
            </section>

          {requestType !== "REGULAR" &&
            <>
              <div className="section-group__header">
                  <h3>몇 명이 수업을 들을 예정인가요?</h3> 
              </div>

              <div className="form-card">
                  <label className="form-card__label">참여 인원</label>
                  <div className="stepper-counter">
                      <span>인원 (본인 포함)</span>
                      <div className="stepper-counter__controls">
                          <button type="button" aria-label="−" onClick={() => setParticipantCount(Math.max(1, participantCount - 1))}><RemoveIcon style={{ fontSize: 18 }} /></button>
                          <strong>{participantCount}명</strong>
                          <button type="button" aria-label="＋" onClick={() => setParticipantCount(Math.min(10, participantCount + 1))}><AddIcon style={{ fontSize: 18 }} /></button>
                      </div>
                  </div>
              </div>
            </>}

            <div className="section-group__header">
                <h3>요청사항이 있나요?</h3> 
                <p>강사님이 참고하실 수 있도록 자세히 적어주세요.</p>
            </div>
            <div className="form-card">
                <label className="form-card__label">원하시는 강습 방향이나 궁금한 점을 남겨주세요.</label>
                <textarea
                    className="large-textarea"
                    placeholder="제가 신청한 협회는 000 입니다, 물공포증이 있습니다."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />
                <span className="text-count-row">{message.length} / 200</span>
            </div>
        </div>
    );
}
